import * as React from 'react';
import { Header1, InlineText1 } from '@cian/ui-kit/typography';
import * as style from './Price.css';

export interface IPriceProps {
  pricePerMeter: string;
  pricePerObject: string;
  priceRelevance: React.ReactElement;
}

export function Price({ pricePerMeter, pricePerObject, priceRelevance }: IPriceProps) {
  return (
    <div className={style['price']}>
      <div className={style['heading']}>
        <Header1 color={'white_100'} fontWeight={'bold'}>
          {pricePerObject}
        </Header1>
        <div className={style['relevance']}>{priceRelevance}</div>
      </div>
      <InlineText1 color={'white_100'}>{pricePerMeter}</InlineText1>
    </div>
  );
}
